import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./label-singleton.scss";
import MsxIcons from "../../../Icons/MsxIcons/MsxIcons";

/**
 * Selectable label. Is used to select one or several properties in the LabelsPicker element.
 * @author Fanny Graille
 */
const LabelSingleton = ({
  label,
  selectedInit,
  disabled,
  error,
  onSelect,
  changeWithInit,
  alwaysSelected,
  number,
  idLabel
}) => {
  const [selected, setSelected] = useState(selectedInit);

  useEffect(() => {
    if (changeWithInit) {
      setSelected(selectedInit);
    }
  }, [selectedInit]);

  return (
    <button
      id={`${idLabel}-${label.replace(/\s/g, "")}`}
      type="button"
      title={label}
      className={`w-auto flex items-center text-sm md:text-xxs m-1 text-center border-[1px] border-gray-300 text-gray-500 py-1 px-4 rounded-full md:rounded-2xl text-ellipsis overflow-hidden whitespace-nowrap transition-all duration-75 ${
        selected ? "selected bg-gray-500 text-white" : "bg-wihte hover:bg-gray-10"
      }${disabled ? "disabled bg-gray-100 hover:bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed" : ""}
      ${error ? "error bg-red-200 text-red-500 cursor-not-allowed" : ""}
      `}
      onClick={() => {
        if (!disabled && !error) {
          onSelect(!selected);
          setSelected(!selected);

          if (alwaysSelected) {
            setSelected(true);
          }
        }
      }}
    >
      <span className="m-auto flex items-center">
        {label}
        {number !== null ? <span className="ml-1">({number})</span> : ""}
      </span>
      {error && <MsxIcons name="alert" size="nano" className="ml-1" />}
    </button>
  );
};

LabelSingleton.propTypes = {
  /**
   * Label displayed inside of the singleton.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /**
   * Is this label selected at initialization?
   */
  selectedInit: PropTypes.bool,
  /**
   * Is this label disabled?
   */
  disabled: PropTypes.bool,
  /**
   * Action to call when the selected state changes.
   */
  error: PropTypes.bool,
  onSelect: PropTypes.func,
  changeWithInit: PropTypes.bool,
  alwaysSelected: PropTypes.bool,
  number: PropTypes.number,
  idLabel: PropTypes.string
};

LabelSingleton.defaultProps = {
  selectedInit: false,
  disabled: false,
  error: false,
  onSelect: () => {},
  changeWithInit: false,
  alwaysSelected: false,
  number: null,
  idLabel: "default-label-singleton"
};

export default LabelSingleton;
